/* Bazan PDP — UGC reviews: drag-to-scroll + infinite loop (mobile carousel). */
(function () {
  'use strict';

  function initTrack(track) {
    if (!track || track._bzInit) return;
    track._bzInit = true;

    var isDown = false, startX = 0, scrollLeftStart = 0;
    track.addEventListener('mousedown', function (e) {
      isDown = true;
      startX = e.pageX - track.offsetLeft;
      scrollLeftStart = track.scrollLeft;
    });
    ['mouseleave', 'mouseup'].forEach(function (evt) {
      track.addEventListener(evt, function () { isDown = false; });
    });
    track.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var x = e.pageX - track.offsetLeft;
      track.scrollLeft = scrollLeftStart - (x - startX) * 1.2;
    });

    // Swipe hint luôn hiển thị — không fade khi scroll sang slide khác.

    var origCards = Array.prototype.slice.call(track.querySelectorAll('.bz-pdp-ugc__card'));
    var origLen = origCards.length;

    var isMobile = window.matchMedia('(max-width: 1023px)').matches;
    var infiniteMode = isMobile && origLen > 1;

    var CLONE_SETS = 2;
    if (infiniteMode) {
      for (var ks = 0; ks < CLONE_SETS; ks++) {
        for (var ci = 0; ci < origLen; ci++) {
          var clnA = origCards[ci].cloneNode(true);
          clnA.setAttribute('aria-hidden', 'true');
          clnA.setAttribute('data-bz-clone', '1');
          track.appendChild(clnA);
        }
        for (var cj = origLen - 1; cj >= 0; cj--) {
          var clnB = origCards[cj].cloneNode(true);
          clnB.setAttribute('aria-hidden', 'true');
          clnB.setAttribute('data-bz-clone', '1');
          track.insertBefore(clnB, track.firstChild);
        }
      }
      track.style.scrollSnapType = 'none';
      track.style.scrollBehavior = 'auto';
    }

    // offsetLeft trên track không tin cậy được (track có thể position:static -> offsetParent
    // là body, offsetLeft không phản ánh track-scroll-space). Dùng rect + scrollLeft.
    function origWidth() {
      if (!origLen) return 0;
      var f = origCards[0], l = origCards[origLen - 1];
      var fRect = f.getBoundingClientRect();
      var lRect = l.getBoundingClientRect();
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return (lRect.left + lRect.width) - fRect.left + gap;
    }
    function origStart() {
      var f = origCards[0];
      if (!f) return 0;
      return f.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
    }

    var teleporting = false;
    function silentSet(pos) {
      teleporting = true;
      var pbBhv = track.style.scrollBehavior;
      var pbSnap = track.style.scrollSnapType;
      track.style.scrollBehavior = 'auto';
      track.style.scrollSnapType = 'none';
      track.scrollLeft = pos;
      void track.offsetWidth;
      track.style.scrollBehavior = pbBhv;
      track.style.scrollSnapType = pbSnap;
      setTimeout(function () { teleporting = false; }, 50);
    }

    function cardScrollPos(card) {
      // Vị trí scrollLeft để card căn giữa track viewport
      var cardRect = card.getBoundingClientRect();
      var trackRect = track.getBoundingClientRect();
      var cardStartInScroll = cardRect.left - trackRect.left + track.scrollLeft;
      return cardStartInScroll + cardRect.width / 2 - track.clientWidth / 2;
    }
    if (infiniteMode) {
      // Default khi vao trang: card DAU (origCards[0]) can giua viewport,
      // khong phai card giua set. Clone phia truoc van cho phep swipe nguoc.
      var doInit = function () {
        var card = origCards[0];
        if (!card) return false;
        var target = cardScrollPos(card);
        if (!isFinite(target)) return false;
        silentSet(Math.max(0, Math.round(target)));
        return true;
      };
      var initTries = 0;
      var initIv = setInterval(function () {
        initTries++;
        if (doInit() || initTries > 20) clearInterval(initIv);
      }, 50);
      window.addEventListener('load', function () { setTimeout(doInit, 100); });
    }

    // ── Mobile (<1024px): 1 slide mỗi cú vuốt ────────────────────────────────
    // CSS scroll-snap không dùng được: infinite loop phải set scrollSnapType
    // 'none' vì snap fight với silent teleport. Nên chặn pan ngang native
    // (touch-action: pan-y) rồi tự xử: kéo theo ngón 1:1, thả ra settle về đúng
    // 1 card kế bên (canh giữa), hoặc về card cũ nếu vuốt chưa tới ngưỡng.
    var mqSnap = window.matchMedia('(max-width: 1023px)');
    function applySnapTouchMode() {
      track.style.touchAction = mqSnap.matches ? 'pan-y' : '';
    }
    applySnapTouchMode();
    if (mqSnap.addEventListener) mqSnap.addEventListener('change', applySnapTouchMode);
    else if (mqSnap.addListener) mqSnap.addListener(applySnapTouchMode);

    // ── Cache hình học: đo 1 lần mỗi layout, sau đó chỉ tính số học ──────────
    // Trước đây nearestCardNow() quét getBoundingClientRect của cả 25 card
    // (orig + 2 bộ clone) mỗi frame -> forced layout liên tục giữa lúc vuốt.
    // Tâm card lưu trong hệ toạ độ scroll (không đổi khi scroll), nên chỉ cần
    // đo lại khi layout đổi: resize, ảnh load xong, đổi breakpoint.
    var geo = null;
    function measureGeo() {
      var tr = track.getBoundingClientRect();
      var base = tr.left - track.scrollLeft; // gốc toạ độ scroll
      var gapStr = getComputedStyle(track).columnGap || getComputedStyle(track).gap;
      var gap = parseFloat(gapStr) || 0;
      var items = [];
      Array.prototype.forEach.call(track.querySelectorAll('.bz-pdp-ugc__card'), function (c) {
        if (!c.offsetWidth) return;
        var r = c.getBoundingClientRect();
        items.push({ el: c, center: r.left + r.width / 2 - base, h: c.offsetHeight });
      });
      var w = 0, start = 0;
      if (origLen) {
        var fr = origCards[0].getBoundingClientRect();
        var lr = origCards[origLen - 1].getBoundingClientRect();
        start = fr.left - base;
        w = (lr.left + lr.width) - fr.left + gap;
      }
      geo = {
        items: items,
        step: origCards[0] ? origCards[0].offsetWidth + gap : track.clientWidth,
        cycle: w,
        start: start
      };
      return geo;
    }
    function ensureGeo() { return geo || measureGeo(); }
    function invalidateGeo() { geo = null; }

    function snapStep() { return ensureGeo().step; }
    // Delta scroll cần cộng để `card` về giữa track — thuần số học từ cache.
    function centerDeltaOf(card) {
      var items = ensureGeo().items;
      var view = track.scrollLeft + track.clientWidth / 2;
      for (var i = 0; i < items.length; i++) {
        if (items[i].el === card) return items[i].center - view;
      }
      var tr = track.getBoundingClientRect();
      var cr = card.getBoundingClientRect();
      return (cr.left + cr.width / 2) - (tr.left + tr.width / 2);
    }
    function nearestEntry() {
      var items = ensureGeo().items;
      var view = track.scrollLeft + track.clientWidth / 2;
      var best = null, bestDist = Infinity;
      for (var i = 0; i < items.length; i++) {
        var d = Math.abs(items[i].center - view);
        if (d < bestDist) { bestDist = d; best = items[i]; }
      }
      return best;
    }
    function nearestCardNow() {
      var e = nearestEntry();
      return e ? e.el : null;
    }

    // ── Swipe hint bám sát đáy card đang xem ─────────────────────────────────
    // Track cao bằng card cao nhất; card ngắn -> khoảng trống dưới body. Đo
    // hiệu số rồi set --bz-ugc-swipe-pull, CSS dùng margin-top âm kéo hint lên.
    var section = track.closest ? track.closest('.bz-pdp-ugc') : null;
    var pullRaf = null;
    var lastPull = null;
    function updateSwipePull() {
      if (!section) return;
      if (!mqSnap.matches) {
        if (lastPull !== null) {
          section.style.removeProperty('--bz-ugc-swipe-pull');
          lastPull = null;
        }
        return;
      }
      var e = nearestEntry();
      if (!e) return;
      // Chiều cao lấy từ cache (offsetHeight là layout read) và chỉ ghi CSS var
      // khi giá trị đổi — trước đây ghi mỗi frame, mỗi lần là 1 style recalc.
      var pull = Math.round(track.clientHeight - e.h);
      if (!isFinite(pull) || pull < 0) pull = 0;
      if (pull === lastPull) return;
      lastPull = pull;
      section.style.setProperty('--bz-ugc-swipe-pull', pull + 'px');
    }
    function scheduleSwipePull() {
      if (pullRaf) return;
      pullRaf = requestAnimationFrame(function () {
        pullRaf = null;
        updateSwipePull();
      });
    }
    function onSnapMqChange() { invalidateGeo(); updateSwipePull(); }
    if (mqSnap.addEventListener) mqSnap.addEventListener('change', onSnapMqChange);
    else if (mqSnap.addListener) mqSnap.addListener(onSnapMqChange);
    window.addEventListener('resize', function () { invalidateGeo(); scheduleSwipePull(); });
    window.addEventListener('load', function () {
      invalidateGeo();
      setTimeout(function () { invalidateGeo(); updateSwipePull(); }, 120);
    });
    // Ảnh lazy load xong -> chiều cao/vị trí card đổi -> đo lại.
    Array.prototype.forEach.call(track.querySelectorAll('img'), function (img) {
      if (img.complete) return;
      img.addEventListener('load', function () { invalidateGeo(); scheduleSwipePull(); });
    });
    setTimeout(updateSwipePull, 0);
    setTimeout(updateSwipePull, 300);

    // RAF smooth scroll wrap-aware: silent teleport nhảy scrollLeft giữa
    // animation -> dịch baseline theo, nếu không animation fight với wrap.
    // easeOutCubic: nhanh ngay lúc thả ngón rồi giảm dần. Ease-in-out có đoạn
    // chậm ở đầu nên cảm giác như bị giật khi ngón vừa rời màn hình.
    function snapSmoothTo(target) {
      if (track._bzSnapAnim) cancelAnimationFrame(track._bzSnapAnim);
      var duration = 380, startT = null, start = track.scrollLeft, lastLeft = start;
      function ease(t) { var u = 1 - t; return 1 - u * u * u; }
      function frame(ts) {
        if (startT === null) startT = ts;
        var pr = Math.min(1, (ts - startT) / duration);
        var jump = track.scrollLeft - lastLeft;
        if (Math.abs(jump) > 100) { start += jump; target += jump; }
        var next = start + (target - start) * ease(pr);
        track.scrollLeft = next;
        lastLeft = next;
        if (pr < 1) track._bzSnapAnim = requestAnimationFrame(frame);
        else { track._bzSnapAnim = null; updateSwipePull(); }
      }
      track._bzSnapAnim = requestAnimationFrame(frame);
    }
    // Center `card` rồi dịch thêm `dir` bước; chuẩn hoá modulo cycle để chọn
    // instance gần nhất (không chạy ngược cả vòng khi card là clone ở xa).
    function snapSettleTo(card, dir, step, cycle) {
      if (!card) return;
      var delta = centerDeltaOf(card) + dir * (step || snapStep());
      var w = cycle != null ? cycle : (infiniteMode ? ensureGeo().cycle : 0);
      if (w) {
        delta = ((delta % w) + w) % w;
        if (delta > w / 2) delta -= w;
      }
      snapSmoothTo(track.scrollLeft + delta);
    }

    if (origLen > 1) {
      var tStartX = 0, tStartY = 0, tLastX = 0, tStartT = 0, tAxis = '', tCard = null;
      var tPendingDX = 0, tRaf = null, tStep = 0, tCycle = 0;

      // Gộp mọi touchmove trong 1 frame thành ĐÚNG 1 lần ghi scrollLeft. Ngón
      // thật bắn ~2-3 touchmove/frame; ghi mỗi lần sẽ tạo 2-3 scroll event/frame
      // -> wrap check đọc rect toàn bộ card nhiều lần trong 1 frame => giật.
      function flushDrag() {
        tRaf = null;
        if (!tPendingDX) return;
        track.scrollLeft -= tPendingDX;
        tPendingDX = 0;
      }

      track.addEventListener('touchstart', function (e) {
        if (!mqSnap.matches || !e.touches || e.touches.length !== 1) return;
        if (track._bzSnapAnim) { cancelAnimationFrame(track._bzSnapAnim); track._bzSnapAnim = null; }
        tStartX = tLastX = e.touches[0].clientX;
        tStartY = e.touches[0].clientY;
        tStartT = Date.now();
        tAxis = '';
        tPendingDX = 0;
        tCard = nearestCardNow();
        // Đo 1 lần cho cả gesture — layout không đổi giữa lúc vuốt.
        var g = ensureGeo();
        tStep = g.step;
        tCycle = infiniteMode ? g.cycle : 0;
      }, { passive: true });

      track.addEventListener('touchmove', function (e) {
        if (!mqSnap.matches || !e.touches || e.touches.length !== 1) return;
        var x = e.touches[0].clientX, y = e.touches[0].clientY;
        if (!tAxis) {
          var adx = Math.abs(x - tStartX), ady = Math.abs(y - tStartY);
          if (adx < 6 && ady < 6) return;
          tAxis = adx > ady ? 'x' : 'y';
        }
        if (tAxis !== 'x') return; // vuốt dọc -> để page scroll bình thường
        e.preventDefault();
        // Cộng dồn delta, KHÔNG tính lại từ tStartX: wrap teleport đổi
        // scrollLeft giữa gesture, tính lại từ start sẽ ghi đè teleport đó.
        tPendingDX += (x - tLastX);
        tLastX = x;
        if (!tRaf) tRaf = requestAnimationFrame(flushDrag);
      }, { passive: false });

      track.addEventListener('touchend', function () {
        if (!mqSnap.matches || tAxis !== 'x') { tAxis = ''; return; }
        if (tRaf) { cancelAnimationFrame(tRaf); tRaf = null; }
        flushDrag();
        var dist = tLastX - tStartX;
        var dt = Math.max(1, Date.now() - tStartT);
        var dir = 0;
        // Qua ngưỡng khoảng cách HOẶC flick nhanh -> đi đúng 1 card.
        if (Math.abs(dist) > 40 || Math.abs(dist) / dt > 0.4) dir = dist < 0 ? 1 : -1;
        snapSettleTo(tCard, dir, tStep, tCycle);
        tAxis = '';
      });

      track.addEventListener('touchcancel', function () {
        if (tRaf) { cancelAnimationFrame(tRaf); tRaf = null; }
        if (tAxis === 'x') snapSettleTo(tCard, 0, tStep, tCycle);
        tAxis = '';
      });
    }

    var wrapTimer = null;
    function runWrap() {
      if (!infiniteMode || teleporting) return;
      var g = ensureGeo();
      var w = g.cycle, s = g.start;
      if (!w) return;
      var sl = track.scrollLeft;
      if (sl >= s + w) {
        var over = sl - s;
        var norm = ((over % w) + w) % w;
        silentSet(s + norm);
      } else if (sl < s) {
        var under = s - sl;
        var norm2 = ((under % w) + w) % w;
        silentSet(s + w - norm2);
      }
    }
    function scheduleWrap() {
      if (wrapTimer) clearTimeout(wrapTimer);
      wrapTimer = setTimeout(runWrap, 140);
    }
    track.addEventListener('scroll', function () {
      scheduleSwipePull();
      if (!infiniteMode || teleporting) return;
      // Không gọi origWidth() ở đây: getComputedStyle + đọc offsetLeft trong
      // handler chạy hàng chục lần mỗi gesture. runWrap/scheduleWrap đã tự đo.
      var sl = track.scrollLeft;
      if (sl <= 2 || sl >= track.scrollWidth - track.clientWidth - 2) runWrap();
      else scheduleWrap();
    }, { passive: true });
  }

  // Lightbox: click photo -> open full-size overlay. Delegated, sống qua re-render.
  function openLightbox(src, alt) {
    var lb = document.createElement('div');
    lb.className = 'bz-pdp-ugc-lightbox';
    lb.innerHTML = '<button type="button" class="bz-pdp-ugc-lightbox__close" aria-label="Close">×</button>'
      + '<img class="bz-pdp-ugc-lightbox__img" src="' + src + '" alt="' + (alt || '') + '">';
    function close() {
      lb.remove();
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    }
    function onKey(e) { if (e.key === 'Escape') close(); }
    lb.addEventListener('click', function (e) {
      if (e.target === lb || e.target.classList.contains('bz-pdp-ugc-lightbox__close')) close();
    });
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    document.body.appendChild(lb);
  }
  document.addEventListener('click', function (e) {
    var img = e.target.closest && e.target.closest('.bz-pdp-ugc__photo');
    if (!img) return;
    e.preventDefault();
    // Ưu tiên largest URL: strip Shopify width param -> load full-size
    var src = img.getAttribute('src') || '';
    var full = src.replace(/(_|-)\d+x\d*(_crop_\w+)?(?=\.[a-z]+(\?|$))/i, '')
                  .replace(/([?&])width=\d+/i, '$1width=1600');
    openLightbox(full || src, img.getAttribute('alt') || '');
  }, false);

  function boot() {
    document.querySelectorAll('[data-bz-ugc-track]').forEach(initTrack);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target && e.target.querySelector('[data-bz-ugc-track]');
    if (t) initTrack(t);
  });
})();

// v=1788946235

// v=1788961173

// v=1788961927

// v=1788962454

// v=1788963092
